import styles from "./analytics-filter.module.css"

export default function AlertsFilter({ filters, setFilters }) {
  return (
    <div className={styles.filterContainer}>
      <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
        <option value="active">Active</option>
        <option value="acknowledged">Acknowledged</option>
        <option value="resolved">Resolved</option>
        <option value="all">All</option>
      </select>

      <select value={filters.severity} onChange={(e) => setFilters({ ...filters, severity: e.target.value })}>
        <option value="">All Severities</option>
        <option value="normal">Normal</option>
        <option value="warning">Warning</option>
        <option value="critical">Critical</option>
      </select>

      <select value={filters.alertType} onChange={(e) => setFilters({ ...filters, alertType: e.target.value })}>
        <option value="">All Types</option>
        <option value="profit">Profit</option>
        <option value="cost">Cost</option>
        <option value="orders">Orders</option>
        <option value="supplier">Supplier</option>
        <option value="system">System</option>
      </select>

      <select value={filters.sortBy} onChange={(e) => setFilters({ ...filters, sortBy: e.target.value })}>
        <option value="priority">Priority</option>
        <option value="occurrenceCount">Occurence Count</option>
      </select>

      <select value={filters.order} onChange={(e) => setFilters({ ...filters, order: e.target.value })}>
        <option value="desc">Descending</option>
        <option value="asc">Ascending</option>
      </select>
    </div>
  )
}
